import { NgModule } from '@angular/core';
import { DxFormArrayDirective } from './form-array.directive';

@NgModule({
  declarations: [ DxFormArrayDirective],
  exports: [ DxFormArrayDirective]
})
export class DxFormArrayDirectiveModule {}
